import { render, staticRenderFns } from "./LYMPH.vue?vue&type=template&id=3fcc8ad6&scoped=true&"
import script from "./LYMPH.vue?vue&type=script&lang=js&"
export * from "./LYMPH.vue?vue&type=script&lang=js&"
import style0 from "./LYMPH.vue?vue&type=style&index=0&id=3fcc8ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcc8ad6",
  null
  
)

export default component.exports